import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'VivaInsights',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.VivaInsights_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.VivaInsights_DisplayText)
    ]
})
export class VivaInsightsLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
}
